import type { Map as MapLibreMap } from 'maplibre-gl'

import type { MapBounds } from '@app/packages/geo/MapBounds'

import { getVisibleBounds } from '@app/components/Map/maplibre'

import { debounce } from './debounce'

export type LocationToolState = {
  center: [number, number]
  zoom: number
  bounds: MapBounds
}

export type Listener = (state: LocationToolState) => unknown

export function readLocationState(map: MapLibreMap): LocationToolState {
  const { lat, lng } = map.getCenter()
  return { center: [lat, lng], zoom: map.getZoom(), bounds: getVisibleBounds(map) }
}

/** Reports where the map settled, once it stops moving. */
export class LocationTool {
  private listeners: Listener[] = []
  private destroyed = false

  constructor(private readonly map: MapLibreMap) {
    map.on('moveend', this.onMapSettle)
    map.on('resize', this.onMapSettle)
  }

  addListener(fn: Listener) {
    this.listeners.push(fn)
  }

  destroy() {
    this.destroyed = true
    this.map.off('moveend', this.onMapSettle)
    this.map.off('resize', this.onMapSettle)
    this.listeners = []
  }

  private onMapSettle = debounce(() => {
    if (this.destroyed) return
    const state = readLocationState(this.map)
    this.listeners.forEach(l => l(state))
  }, 100)
}
